export const FIND_PROCESS_STATEMENT_RESULTS_SUCCESS = 'FIND_PROCESS_STATEMENT_RESULTS_SUCCESS';

export const findProcessStatementResultsSuccess = ({ processStatement, results }) => ({
    type: FIND_PROCESS_STATEMENT_RESULTS_SUCCESS,
    payload: { processStatement, results },
});
